import { EViewTypes, VIEW_TYPES_KANBAN_OTHER, VIEW_TYPES_SWIM } from 'app/const';

export const isKanbanGroup = (
    view: EViewTypes,
): boolean => {
    return VIEW_TYPES_KANBAN_OTHER.includes(view) || VIEW_TYPES_SWIM.includes(view);
};
